angular.module("PWAPoCApp").factory("consoleCapture", [
    "$rootScope",
    function ($rootScope) {
        let logs = [];
        const original = {
            log: console.log,
            warn: console.warn,
            error: console.error,
            info: console.info,
        };

        function safeToString(arg) {
            try {
                if (typeof arg === "object") {
                    return JSON.stringify(arg, (k, v) => {
                        if (v === window) return "[window]";
                        if (v === document) return "[document]";
                        return v;
                    });
                }
                return String(arg);
            } catch (e) {
                return String(arg);
            }
        }

        function capture(type, args) {
            const entry = {
                time: new Date(),
                type,
                message: args.map((a) => safeToString(a)).join(" "),
            };

            logs.unshift(entry);

            original[type].apply(console, args);

            $rootScope.$applyAsync();
        }

        function clear() {
            logs.length = 0;
            $rootScope.$applyAsync();
        }

        console.log = (...args) => capture("log", args);
        console.warn = (...args) => capture("warn", args);
        console.error = (...args) => capture("error", args);
        console.info = (...args) => capture("info", args);

        return {
            logs,
            clear,
        };
    }
]);
